import { IForm } from './IForm';
import { ErrorHandler } from '../errors/error-handler';
import { LogService } from '../services/log.service';
import { environment } from '../../environments/environment';
import { OnDestroy } from '@angular/core';

export abstract class BaseForm implements IForm, OnDestroy {
  protected errorHandler: ErrorHandler;
  protected isSubmitInProgress = false;
  isSuccess = false;
  errorMsg = '';
  protected onErrorCallback: Function;
  closeTimeoutInSeconds = environment.settings.forms.close_timeout / 1000;
  protected closeTimer: number;

  protected constructor(private log2: LogService) {
    this.errorHandler = new ErrorHandler(log2);
    this.onErrorCallback = err => {
      this.log2.error('BaseForm.onErrorCallback', err.error);
      this.clear();

      const error = err.error ? err.error : err;
      this.errorMsg = this.errorHandler.get(error);

      this.isSubmitInProgress = false;
    };
  }

  ngOnDestroy() {
    this.stopTimer();
  }

  abstract isValid(): boolean;

  abstract clear();

  abstract submit();

  protected startTimer2Sec(onTimeout: Function) {
    this.closeTimer = window.setInterval(() => {
      this.closeTimeoutInSeconds -= 1;
      if (this.closeTimeoutInSeconds <= 0) {
        this.log2.trace('close timeout activated');
        this.stopTimer();
        onTimeout();
      }
    }, 200);
  }

  protected startTimer(onTimeout: Function) {
    this.closeTimer = window.setInterval(() => {
      this.closeTimeoutInSeconds -= 1;
      if (this.closeTimeoutInSeconds <= 0) {
        this.log2.trace('close timeout activated');
        this.stopTimer();
        onTimeout();
      }
    }, 1000);
  }

  protected stopTimer() {
    if (this.closeTimer) {
      window.clearInterval(this.closeTimer);
      this.closeTimer = null;
    }
  }
}
